import { FC } from "react";
import Camera from "react-html5-camera-photo";

import "react-html5-camera-photo/build/css/index.css";

import { DsIcon } from "./DsIcon";

type DsCameraPropsType = {
  onTakePhoto: (uri: string) => void;
  onCancelClick?: () => void;
};

const DsCamera: FC<DsCameraPropsType> = ({ onTakePhoto, onCancelClick }) => {
  const handleCancelClick = () => onCancelClick?.();
  const handleTakePhoto = (dataUri: string) => onTakePhoto(dataUri);

  return (
    <div className="fixed bottom-0 top-0 left-0 right-0 max-w-[100vw]">
      <div className="w-full flex justify-end my-4">
        <div
          onClick={handleCancelClick}
          className="rounded-full p-2 bg-white hover:cursor-pointer mr-4">
          <DsIcon icon="Close" />
        </div>
      </div>
      <Camera
        onTakePhotoAnimationDone={handleTakePhoto}
        isFullscreen={false}
        isSilentMode
        imageCompression={0.8}
        idealFacingMode="environment"
      />
    </div>
  );
};
export { DsCamera };
